import { message } from 'antd';
import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function fetchCalendarEventDetail(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchCalendarEventDetail?eventId=${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByMeetingId(meetingId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByMeetingId/${meetingId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllMeeting(id, type, page) {
    try {
        const response = await getAxiosInstance().get(`/findAllMeetingActivityByEntityAndId/${id}/${type}?page=${page}&limit=20`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllMeeting1(id, type) {
    try {
        const response = await getAxiosInstance().get(`/findAllMeetingActivityByEntityAndId/${id}/${type}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllRecentMeetings(StartDate, EndDate) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchCalendarEventData?startDate=${StartDate}&endDate=${EndDate}`, { headers });
        return response;
    } catch (err) {
        message.error("Email connection error. Update your settings to restore access")
    }
};
async function addMeetingNote(id, messahe) {
    try {
        const payload = {
            meetingNote: messahe
        }
        const response = await getAxiosInstance().put(`/addMeetingNote/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function respondToMeetingInvite(id, value, comments, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/respondToMeetingInvite/${id}/${value}${(comments && comments !== "") ? `?comment=${comments}` : ""}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteAttendeEvent(url) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteAttendeEvent${url}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchEventAccessCodeUrl() {
    try {
        const response = await getAxiosInstance().get(`/fetchEventAccessCodeUrl`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateEmailConfiguration(id, payload) {
    try {
        const response = await getAxiosInstance().put(`/updateEmailConfiguration/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createEmailConfiguration(payload) {
    try {
        const response = await getAxiosInstance().post(`/createEmailConfiguration`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteEmailConfiguration(id) {
    try {
        const data = await getAxiosInstance().delete(`/deleteEmailConfiguration/${id}}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function setCredentials(payload) {
    try {
        const response = await getAxiosInstance().post(`/setCredentials`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function setOutlookCredentials(payload) {
    try {
        const response = await getAxiosInstance().post(`/setOutlookCredentials`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTokens(payload, code) {
    try {
        const response = await getAxiosInstance().post(`/getTokens/${code}`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAuthUrl() {
    try {
        const response = await getAxiosInstance().get(`/getAuthUrl`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getOutlookAuthUrl() {
    try {
        const response = await getAxiosInstance().get(`/getOutlookAuthUrl`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createMeetings(linkType, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createMeetings/${linkType}`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateMeetings(queryData, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateMeetings${queryData}`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function cancelMeeting(queryData, payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/cancelMeeting${queryData}`, {
            headers,
            data: payload,
        });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    fetchAllMeeting1,
    getTokens,
    getAuthUrl,
    getOutlookAuthUrl,
    setOutlookCredentials,
    deleteEmailConfiguration,
    updateEmailConfiguration,
    fetchEventAccessCodeUrl,
    deleteAttendeEvent,
    respondToMeetingInvite,
    fetchAllMeeting,
    FetchAllRecentMeetings,
    getByMeetingId,
    addMeetingNote,
    fetchCalendarEventDetail,
    createEmailConfiguration,
    setCredentials,
    createMeetings,
    updateMeetings,
    cancelMeeting,
}